import React, { useState } from 'react';
import { useConfirm } from '../contexts/ConfirmContext';

const MODE_LABELS = {
  cast_select:  { label: 'キャスト選択', icon: '🎭' },
  guest_select: { label: 'ゲスト選択',   icon: '👤' },
  both_select:  { label: '両想い',        icon: '💞' },
  random_only:  { label: 'ランダム',      icon: '🎲' },
};

const EVENT_TYPE_LABELS = {
  cast_instance: { label: 'インスタンス', icon: '🏘️' },
};

const STATUS_CONFIG = {
  waiting:  { label: '準備中',   dot: '#f59e0b' },
  matching: { label: '受付中',   dot: '#6c63ff' },
  matched:  { label: 'マッチ済', dot: '#10b981' },
};

const EventList = ({ events, selectedEventId, onSelect, onDelete, canDelete }) => {
  const confirm = useConfirm();
  const [hoveredId, setHoveredId] = useState(null);
  const [hoveredDeleteId, setHoveredDeleteId] = useState(null);
  const eventIds = Object.keys(events);

  if (eventIds.length === 0) {
    return (
      <div style={{
        fontSize: '12px', color: '#334155', textAlign: 'center',
        padding: '20px 12px', lineHeight: 1.6,
      }}>
        イベントがありません<br />
        <span style={{ color: '#1e2a45', fontSize: '11px' }}>+ ボタンで作成してください</span>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      {eventIds.map((id) => {
        const event = events[id];
        const isSelected = selectedEventId === id;
        const isHovered = hoveredId === id && !isSelected;
        const status = STATUS_CONFIG[event.status] || STATUS_CONFIG.waiting;
        const mode = EVENT_TYPE_LABELS[event.event_type] || MODE_LABELS[event.matching_mode] || MODE_LABELS.cast_select;

        return (
          <div
            key={id}
            onClick={() => onSelect(id)}
            onMouseEnter={() => setHoveredId(id)}
            onMouseLeave={() => setHoveredId(null)}
            style={{
              padding: '10px 12px',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.15s',
              background: isSelected
                ? 'rgba(108,99,255,0.18)'
                : isHovered
                  ? 'rgba(255,255,255,0.07)'
                  : 'rgba(255,255,255,0.03)',
              border: isSelected
                ? '1px solid rgba(108,99,255,0.5)'
                : '1px solid rgba(255,255,255,0.07)',
            }}
          >
            {/* Name row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '6px', marginBottom: '6px' }}>
              <span style={{
                fontSize: '13px',
                fontWeight: isSelected ? '700' : '600',
                color: isSelected ? '#fff' : isHovered ? '#e2e8f0' : '#cbd5e1',
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                lineHeight: 1.4,
              }}>
                {event.event_name}
              </span>
              {onDelete && (!canDelete || canDelete(id)) && (
                <button
                  onMouseEnter={(e) => { e.stopPropagation(); setHoveredDeleteId(id); }}
                  onMouseLeave={(e) => { e.stopPropagation(); setHoveredDeleteId(null); }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    if (await confirm({ message: 'このイベントを削除しますか？', type: 'danger' })) onDelete(id);
                  }}
                  style={{
                    background: 'none', border: 'none',
                    color: hoveredDeleteId === id ? '#f87171' : '#334155',
                    cursor: 'pointer', fontSize: '14px', padding: '0 2px',
                    lineHeight: 1, flexShrink: 0,
                    transition: 'color 0.15s',
                  }}
                >
                  ×
                </button>
              )}
            </div>

            {/* Meta row */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              {/* Status dot + label */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span style={{
                  display: 'inline-block', width: '5px', height: '5px',
                  borderRadius: '50%', background: status.dot, flexShrink: 0,
                }} />
                <span style={{ fontSize: '10px', color: '#475569', fontWeight: '600' }}>
                  {status.label}
                </span>
              </div>
              <span style={{ color: '#1e2a45', fontSize: '10px' }}>·</span>
              {/* Mode */}
              <span style={{ fontSize: '10px', color: '#334155' }}>
                {mode.icon} {mode.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EventList;
